import type { SVGMotionProps, Transition } from 'motion/react'
import { motion } from 'motion/react'
import { useId } from 'react'

const transition: Transition = {
  duration: 0.6,
  type: 'spring',
  bounce: 0.5,
}

export const Bag = ({
  isHovered,
  ...props
}: SVGMotionProps<SVGSVGElement> & { isHovered?: boolean }) => {
  const id = useId()

  return (
    <motion.svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      whileHover="hover"
      animate={isHovered ? 'hover' : undefined}
      {...props}
    >
      <mask
        id={id}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <motion.rect
          width={20}
          fill="black"
          transition={transition}
          initial={{ height: 4 }}
          variants={{ hover: { height: 6 } }}
        />
      </mask>
      <motion.g
        transition={transition}
        initial={{ y: 0 }}
        variants={{ hover: { y: 2 } }}
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.3}
          d="M14.486 3.625c.296 0 .547.045.822.147.274.103.489.232.702.422.214.19.361.384.483.634.121.25.18.481.191.755l.374 8.67c.013.29-.03.536-.141.806-.11.27-.255.481-.47.69-.216.208-.438.35-.725.463a2.24 2.24 0 0 1-.862.163H5.14c-.312 0-.576-.05-.862-.163a2.106 2.106 0 0 1-.725-.464 1.928 1.928 0 0 1-.47-.69 1.817 1.817 0 0 1-.141-.804l.373-8.67c.012-.275.07-.505.192-.756.122-.25.269-.444.482-.634.214-.19.428-.319.703-.421a2.24 2.24 0 0 1 .821-.148h8.973Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.3}
          d="M12.2 6.406a2.2 2.2 0 0 1-4.4 0"
        />
      </motion.g>
      <g mask={`url(#${id})`}>
        <motion.g
          transition={transition}
          initial={{ y: 1, opacity: 0 }}
          variants={{ hover: { y: -2, opacity: 1 } }}
        >
          <path
            stroke="currentColor"
            strokeWidth={1.3}
            d="m5.226 4.639 4.808-1.289a1.1 1.1 0 0 1 1.347.778l.961 3.588a1.1 1.1 0 0 1-.777 1.348l-4.808 1.288a1.1 1.1 0 0 1-1.347-.778l-.962-3.588a1.1 1.1 0 0 1 .778-1.347Z"
          />
          <path
            stroke="currentColor"
            strokeWidth={1.3}
            d="m11.356 5.54 1.293.077 1.848.111a.705.705 0 0 1 .28.074.702.702 0 0 1 .23.174.703.703 0 0 1 .145.249.705.705 0 0 1 .039.286l-.044.738-.045.738"
          />
        </motion.g>
      </g>
    </motion.svg>
  )
}
